var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{class:{
        'align-start': !_vm.isMobile,
        'justify-center': !_vm.isMobile,
        row: !_vm.isMobile,
        'pa-3': !_vm.isMobile,
        'align-center': _vm.isMobile,
        'justify-start': _vm.isMobile,
        column: _vm.isMobile,
        'pa-0': _vm.isMobile,
    },attrs:{"fill-height":""}},[_c('v-flex',{staticClass:"py-2",class:{
            'pr-3': !_vm.isMobile,
        },attrs:{"shrink":""}},[_c('nem-card-wallet')],1),_c('v-flex',{staticClass:"py-2"},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-flex',[_c('WalletFAQ')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }